/**
 * @fileoverview GET handler for the "/decisioning_studio_agents/:app_group_id/:dsa_id/constraints" endpoint.
 * Query params (dimension, regime, active) are passed via the params argument so they are part of the query key.
 */
import fetch from "@lib/fetch";

import { reactQueryFetcherAdapter } from "../reactQueryFetcherAdapters";
import { decisioningStudioAgentsAppGroupIdDsaIdConstraints } from "./constants";
import type {
  GetDecisioningStudioAgentsAppGroupIdDsaIdConstraintsParams,
  GetDecisioningStudioAgentsAppGroupIdDsaIdConstraintsResult,
} from "./types";
import { isGetDecisioningStudioAgentsAppGroupIdDsaIdConstraintsResult } from "./validators";

export const getDecisioningStudioAgentsAppGroupIdDsaIdConstraints = reactQueryFetcherAdapter(
  decisioningStudioAgentsAppGroupIdDsaIdConstraints,
  (
    signal: AbortSignal,
    appGroupId: string,
    dsaId: string,
    params: GetDecisioningStudioAgentsAppGroupIdDsaIdConstraintsParams
  ): Promise<GetDecisioningStudioAgentsAppGroupIdDsaIdConstraintsResult> => {
    const queryParams: Record<string, string> = {};
    if (params.dimension !== undefined) {
      queryParams.dimension = params.dimension;
    }
    if (params.regime !== undefined) {
      queryParams.regime = params.regime;
    }
    if (params.active !== undefined) {
      queryParams.active = params.active;
    }
    return fetch(`/decisioning_studio_agents/${appGroupId}/${dsaId}/constraints`, "GET", queryParams, { signal });
  },
  isGetDecisioningStudioAgentsAppGroupIdDsaIdConstraintsResult
);
